import React from "react";
import { Box, Text, Button } from "@mantine/core";
import { DateTime } from "luxon";

import { FILTER_INPUT_COMPONENTS } from "./inputs";

import { displayEmoji } from "../../../../utils/Emoji";
import { dateFormat } from "../../../../utils/Filters";

export default function FilterDropdownValueSelector({ filter, optionCounts, topLocations, onUpdateFilter, onClearFilter }) {
  if (!filter) return null;

  const Component = FILTER_INPUT_COMPONENTS[filter.format];
  const selectedOptions = Array.isArray(filter.selectedOptions) ? filter.selectedOptions : [];

  const showFilterText = () => {
    const selectedOption = selectedOptions[0];
    const selectedOptionsNames = Array.isArray(filter.options?.values) ?
      filter.options.values.filter((option) => selectedOptions.includes(option.value)).map((option) => option.name)
    : [];
    switch (filter.format) {
      case "text":
      case "url":
      case "number":
      case "location":
        return `${selectedOption || "None"}`;
      case "date":
        const _format = dateFormat.find((d) => d.value === filter.options?.format)?.format || "DDD";
        return selectedOption ? DateTime.fromISO(selectedOption).toFormat(_format) : "None";
      case "select":
      case "multi_select":
        return selectedOptionsNames.length > 0 ? selectedOptionsNames.join(", ") : "None";
      default:
        return "None";
    }
  };

  return (
    <Box mr={10}>
      {Component ? (
        <Component
          type="panel"
          filter_id={filter.id}
          value={filter.value}
          isEditMode={true}
          options={filter.options}
          selectedOptions={selectedOptions}
          color={filter.color}
          filterFormat={filter.format}
          label={filter.name}
          shouldOpenDropdown={filter.shouldOpenDropdown}
          optionCounts={optionCounts}
          topLocations={topLocations}
          TargetComponent={({ onClick }) => (
            <Button variant="default" radius="md" size="xs" onClick={onClick}>
              {displayEmoji(filter.emojicon, "grey")}
              <Text color="grey" size="xs" ml={5}>
                {filter.name}: {showFilterText()}
              </Text>
            </Button>
          )}
          onChange={onUpdateFilter}
          onClickRemove={selectedOptions.length > 0 ? () => onUpdateFilter(null) : undefined}
          onClearFilter={onClearFilter}
        />
      ) : null}
    </Box>
  );
}